import { defineStore } from 'pinia'
import { IStore } from '@/system-modules/groups/v1/core/interface/IStore'

export default defineStore('systemGroupsStoreV1', {
  state: (): IStore => {
    return {
      userUuid: '',
      groups: [],
      members: {},
      invites: {},
    }
  },
})
